// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dc3a3811","455":"1d4958a1","977":"6d1ab407"}[chunkId] + ".chunk.js";
};